import { useEffect, useRef } from 'react';

const TradingViewTicker = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Limpiamos contenido previo
    containerRef.current.innerHTML = "";

    const script = document.createElement('script');
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;

    // Configuración del widget como JSON en textContent
    script.textContent = JSON.stringify({
      symbols: [
        { description: "", proName: "SPY" },
        { description: "", proName: "NASDAQ:NDX" },
        { description: "", proName: "OANDA:EURUSD" },
        { description: "", proName: "NASDAQ:NVDA" },
        { description: "", proName: "NASDAQ:GOOG" },
        { description: "", proName: "NASDAQ:AMZN" },
        { description: "", proName: "NASDAQ:TSLA" },
        { description: "", proName: "NASDAQ:META" },
        { description: "", proName: "NASDAQ:MSFT" },
        { description: "", proName: "NASDAQ:AAPL" }
      
      ],
      showSymbolLogo: true,
      colorTheme: "light",
      isTransparent: false,
      displayMode: "regular",
      locale: "es"
    });

    containerRef.current.appendChild(script);

    // Cleanup al desmontar
    return () => {
      if (containerRef.current) containerRef.current.innerHTML = "";
    };
  }, []);

  return <div ref={containerRef} style={{ width: "100%", height: "60px" }} />;
};

export default TradingViewTicker;
